module.exports = __webpack_public_path__ + "static/media/1960.2a21a551.jpeg";